import { Currency } from '@/api/types/public';
import Button from '@/components/Button';

import { IS_DE_FR } from '@/utils/constants';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

export default function PlaceOrderButtonWap({
  shippingActuallyPrice = '0',
  grandTotal = 0,
  currency,
  goToPlaceOrder,
  paymentType,
  loading,
}: {
  shippingActuallyPrice: string;
  grandTotal: number;
  currency: Currency;
  goToPlaceOrder: () => void;
  paymentType: string;
  loading: boolean;
}) {
  const t = useTranslations('payment.PlaceOrderButton');
  const isPaypal = useMemo(() => {
    return paymentType === 'paypal';
  }, [paymentType]);

  return (
    <div className="fixed left-0 bottom-0 px-16 w-full h-[54px] flex items-center justify-between bg-white z-[1111] box-border">
      <div className="text-[20px] font-bb text-primary-text w-[calc(100%-170px)] text-right leading-[1.2] mr-14">
        <p className="">{formatPriceNumberWithSymbol(grandTotal.toString(), currency)}</p>
        {!!parseFloat(shippingActuallyPrice) && (
          <p className="font-br text-[12px] text-warning whitespace-nowrap ">
            ( {t('includingShipping')}{' '}
            {formatPriceNumberWithSymbol(shippingActuallyPrice.toString(), currency)} )
          </p>
        )}
      </div>

      <div className="relative">
        <div
          id="paypal-btn"
          className={`${!isPaypal ? 'pointer-events-none' : ''} w-[145px] h-[40px] absolute bottom-0 right-0 rounded-[70px] opacity-0 z-[996] `}
        />
        <Button
          className={`${isPaypal ? 'pointer-events-none' : ''} w-[145px] h-[40px] bg-primary-purple text-white rounded-[70px] text-[18px] font-bb flex items-center justify-center z-[997] opacity-100 border-none  `}
          onClick={() => {
            goToPlaceOrder();
          }}
          loading={loading}
          variant="contained"
          sx={{
            fontSize: '16px',
            fontFamily: 'var(--font-bricolage-bold)',
            borderRadius: '28px',
          }}
          style={IS_DE_FR ? { lineHeight: 1.2 } : {}}
        >
          {t('placeOrder')}
        </Button>
      </div>
    </div>
  );
}
